/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';

import rightArrow from './../../../assets/images/right_arrow.svg';
import helpers from '../helpers';
import './LocationLayover.scss';

Modal.setAppElement('#root');

const searchLocation = (locations, searchkey, auth) => {
  const nonBrandLocation = auth.is_phone_assigned
    ? locations
    : locations.filter((location) => !helpers.isBrandLocation(location));
  if (searchkey) {
    const filered_locations = nonBrandLocation.filter((location) =>
      location.business_name.toUpperCase().includes(searchkey.toUpperCase()),
    );
    return sorttLocationAlphabetically(filered_locations);
  } else {
    return sorttLocationAlphabetically(nonBrandLocation);
  }
};
const sorttLocationAlphabetically = (locations) => {
  locations.sort((a, b) => {
    return a.business_name.localeCompare(b.business_name);
  });
  return locations.sort((a, b) => {
    return a.brand_ids.includes(a.studioId)
      ? -1
      : b.brand_ids.includes(b.studioId)
      ? 1
      : 0;
  });
};

const generateTemplate = (text, highlight, isBrand) => {
  if (highlight) {
    const parts = text.split(new RegExp(`(${highlight})`, 'gi'));
    const parsedString = (
      <span>
        {parts.map((part) =>
          part.toLowerCase() === highlight.toLowerCase() ? <b>{part}</b> : part,
        )}
        {isBrand && <b>- Brand</b>}
      </span>
    );
    return parsedString;
  } else {
    return (
      <span>
        {text} {isBrand && <b>- Brand</b>}
      </span>
    );
  }
};

class LocationLayover extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.state = {
      list: [],
      search: '',
    };
  }
  componentDidMount() {}
  componentWillReceiveProps(nextProps) {}
  closeModal() {
    this.props.setLocationOverlayVisibility(false);
  }
  setVisibility(flag) {
    this.props.setLocationOverlayVisibility(flag);
  }
  inputSearch = (value) => {
    this.setState({
      search: value,
    });
  };
  render() {
    const { modelopen, locations, setSelectedLocation, auth } = this.props;
    console.log('Auth', auth);
    const { search } = this.state;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="overlay-top"
          contentLabel="Example Modal"
        >
          <div>
            <div className="modal-header">
              <button className="modal-close" onClick={this.closeModal}>
                X
              </button>
              <div className="layover-title">
                Choose account to start new conversation.
              </div>
            </div>
            <div className="location-list">
              <div className="search-box">
                <div className="input-holder">
                  <input
                    type="text"
                    placeholder="Search"
                    value={search}
                    onChange={(e) => this.inputSearch(e.target.value)}
                    className="location-search"
                  />
                  <i className="material-icons">search</i>
                </div>
              </div>
              <div className="location-menu">
                {searchLocation(locations, search, auth).map((location) => {
                  return (
                    <div
                      className="location-menu_location-info"
                      onClick={() => setSelectedLocation(location)}
                    >
                      <div className="name">
                        {generateTemplate(
                          location.business_name,
                          search,
                          location.is_brand,
                        )}
                      </div>
                      <div>
                        <img src={rightArrow} />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default LocationLayover;
